"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnpublishedParagraph = exports.UnpublishedTitle = exports.StyledUnPublishBox = exports.StyledUnPublishWrapperBox = exports.Image = exports.CoverPhoto = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _MediaQueries = _interopRequireDefault(require("../../../MediaQueries"));

var _StyledLayout = require("../../../StyledLayout");

var _SocialGroup = _interopRequireDefault(require("../components/SocialGroup"));

var _StyledTypography = require("../../../StyledTypography");

var _templateObject, _templateObject2;

var CoverPhoto = _styledComponents["default"].div.withConfig({
  displayName: "Elements__CoverPhoto",
  componentId: "sc-1yj58kj-0"
})(["height:100vh;width:100%;background:", ";"], function (props) {
  return props.theme.veryDarkGrey;
});

exports.CoverPhoto = CoverPhoto;

var Image = _styledComponents["default"].img.withConfig({
  displayName: "Elements__Image",
  componentId: "sc-1yj58kj-1"
})(["width:100%;height:100%;object-fit:cover;"]);

exports.Image = Image;
var StyledUnPublishWrapperBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__StyledUnPublishWrapperBox",
  componentId: "sc-1yj58kj-2"
})(["position:absolute;top:0;left:0;height:100vh;width:100vw;padding:", ";"], function (props) {
  return props.theme.spacingMd;
});
exports.StyledUnPublishWrapperBox = StyledUnPublishWrapperBox;
var StyledUnPublishBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__StyledUnPublishBox",
  componentId: "sc-1yj58kj-3"
})(["width:331px;background:", ";padding:", ";min-height:260px;p{max-width:464px;}", ""], function (props) {
  return props.theme.white;
}, function (props) {
  return "".concat(props.theme.spacingXl, " ").concat(props.theme.spacingMd, " 56px");
}, _MediaQueries["default"].minWidth.medium(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    width: 592px;\n    min-height: 388px;\n    padding: ", ";\n  "])), function (props) {
  return "".concat(props.theme.spacingXxl, " ").concat(props.theme.spacingXl, " 96px");
}));
exports.StyledUnPublishBox = StyledUnPublishBox;
var UnpublishedTitle = (0, _styledComponents["default"])(_StyledTypography.Paragraph).withConfig({
  displayName: "Elements__UnpublishedTitle",
  componentId: "sc-1yj58kj-4"
})(["align-self:center;font-size:22px;line-height:", ";@media (min-width:", "px){line-height:", ";font-size:", ";}"], function (props) {
  return props.theme.lineHeightLogo;
}, function (props) {
  return props.theme.responsiveMedium;
}, function (props) {
  return props.theme.lineHeightLogoLarge;
}, function (props) {
  return props.theme.fontSizeLogoLarge;
});
exports.UnpublishedTitle = UnpublishedTitle;
var UnpublishedParagraph = (0, _styledComponents["default"])(_StyledTypography.Paragraph).withConfig({
  displayName: "Elements__UnpublishedParagraph",
  componentId: "sc-1yj58kj-5"
})(["align-self:center;margin-bottom:48px;", ""], _MediaQueries["default"].minWidth.medium(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n    margin-bottom: ", ";\n  "])), function (props) {
  return props.theme.spacingXl;
}));
exports.UnpublishedParagraph = UnpublishedParagraph;